/*
 * @Descripttion:
 * @Author: sjq
 * @Date: 2020-12-14 08:16:56
 * @LastEditors: voanit
 * @LastEditTime: 2022-06-06 14:38:00
 */
import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getUnify, removeUnify } from '@/utils/auth'
import router from '@/router'
const url = process.env.VUE_APP_BASE_API
import qs from 'qs'
let showModal = false
const timeout = res => {
  if (showModal) return
  showModal = true
  store.dispatch('FedLogOut')
  // router.push(`/login?redirect=${router.history.current.fullPath}`)
  router.push(`/login`)
  MessageBox.alert(res.message, '提示', {
    confirmButtonText: '确定',
    type: 'warning',
    callback: action => {
      showModal = false
      // window.location.reload()
    }
  })
}
// create an axios instance
const service = axios.create({
  baseURL: url,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 3000000
  //
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['clientType'] = 1
    if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
      if (config.headers['Content-Type'] !== 'application/json') {
        if (config.headers['Content-Type'] === 'multipart/form-data;') {
          config.paramsSerializer = function (params) {
            return qs.stringify(params)
          }
        } else {
          const params = new URLSearchParams()
          for (const key in config.data) {
            if (config.data.hasOwnProperty(key)) {
              params.append(key, config.data[key])
            }
          }
          config.data = params
        }
      }
    } else if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'brackets' }) && qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    if (getUnify()) {
      config.headers['authorization'] = getUnify()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.config.responseType === 'blob') {
      if (res.type.indexOf('application/json') >= 0) {
        return response.data.text().then(text => {
          try {
            const textres = JSON.parse(text)
            if (textres.code === 3001 || textres.code === 2000 || textres.code === 1001 || textres.code === 1000) {
              timeout(textres)
            }
            if (textres.code == 6000) {
              return Promise.resolve(textres)
            } else if (textres.code != 1) {
              Message({
                message: textres.message || '系统异常，请联系IT老师',
                type: 'error',
                duration: 5 * 1000,
                customClass: 'msgzindx'
              })
              return Promise.reject(textres)
            }
          } catch {}
        })
      } else {
        response.data.text().then(text => {
          try {
            const textres = JSON.parse(text)
            if (textres.code === 3001 || textres.code === 2000 || textres.code === 1001 || textres.code === 1000) {
              timeout(textres)
            }
          } catch {}
        })
      }
      let fileName = response.headers?.['content-disposition']?.split('=')[1]
      if (fileName) {
        try {
          res['fileName'] = decodeURIComponent(fileName.slice(1, -1))
        } catch {
          //URI malformed错误，将%全部替换为%25
          res['fileName'] = decodeURIComponent(fileName.replace(/%/g, '%25').slice(1, -1))
        }
      }
      return res
    }

    // if the custom status is not 20000, it is judged as an error.
    if (res.code === 1000 || res.code === 1001 || res.code === 2000 || res.code === 3001) {
      timeout(res)
      // return Promise.reject(new Error(res.message || '系统异常，请联系IT老师'))
    }
    // else if (res.code === 400) {
    //   // 导入切片
    //   return res
    // }
    else if (res.code !== 1) {
      if (response.config.nomessage) {
        return Promise.reject(res)
      } else {
        Message({
          message: res.message || '系统异常，请联系IT老师',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(res || new Error('系统异常，请联系IT老师'))
      }
    } else {
      if (response.config.needCode) {
        //返回code
        return res
      } else {
        return res.data
      }
    }
  },
  error => {
    Message({
      message: (error.response.data && error.response.data.message) || error,
      type: 'error',
      duration: 5 * 1000
    })
    if (error.response.data.code === 500 && process.env.NODE_ENV !== 'development') {
      console.log(process.env.NODE_ENV)
      setTimeout(() => {
        window.location.href = process.env.VUE_APP_LOGOUT
      }, 500)
      // 重新登陆
    }
    return Promise.reject(error)
  }
)

/**
 * []请求
 * @param params  参数
 * @param operation     接口
 */
function request(data) {
  // var _a = {
  //   url: url,
  //   method: method
  // }
  // var datatype = method === 'get' || method === 'GET' ? 'params' : 'data'
  // _a[datatype] = data
  // console.log(_a)
  return service(data)
}

export { request, service }
